import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { makeStyles, useTheme } from '@material-ui/core/styles';

//Start Css Code ....
const useStyles = makeStyles((theme) => ({ 
  footerBlock:{
    position: 'fixed', 
    bottom: '0', 
    background: '#fff', 
    width: '100%', 
    zIndex: '11',
    '@media only screen and (max-width: 3500px)': {
      height: '22px',
    },
    '@media only screen and (min-width: 3501px)': {
      height: '42px',
    },
    '& p':{
      padding: '5px',
      textAlign: 'center', 
      margin: '0px',
      '@media only screen and (max-width: 3500px)': {
        fontSize:'11px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize:'20pt',
      },     
      '& a':{
        textDecoration: 'none', 
        color: '#24618E',        
        '@media only screen and (max-width: 3500px)': {
          fontSize:'11px',
        },
        '@media only screen and (min-width: 3501px)': {
          fontSize:'20pt',
        },
      }
    }
  }
}));
//End Css Code ....

//Start Footer component code ....
const Footer = () => {
  const classes = useStyles();

  return (
    <React.Fragment>      
      <div id="footer" className={classes.footerBlock}>
        <p>© {new Date().getFullYear()} Quality Counts, LLC &nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<NavLink to='/privacy_policy'>Privacy Policy</NavLink></p>
      </div>
    </React.Fragment>
  );
}

export default Footer;
//End Footer component code ....